// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cjxs","right":"styles_right__19_Em"};